import advertisingLimit from './limit-detectors/advertising-limit';
import analyticsLimit from './limit-detectors/analytics-limit';
import premiumBlocksLimit from './limit-detectors/premium-blocks-limit';
import premiumIconsLimit from './limit-detectors/premium-icons-limit';
import mobilePlusLimit from './limit-detectors/mobile-plus-limit';
import customCodeLimit from './limit-detectors/custom-code-limit';
import brandedFooterLimit from './limit-detectors/branded-footer-limit';
import brandedHeaderLimit from './limit-detectors/branded-header-limit';
import pagesLimit from './limit-detectors/pages-limit';
import storageLimit from './limit-detectors/storage-limit';
import uploadFileSizeLimit from './limit-detectors/upload-file-size-limit';
import onlineStoreLimit from './limit-detectors/online-store-limit';
import siteBackupsLimit from './limit-detectors/site-backups-limit';
import multilingualLimit from './limit-detectors/multilingual-limit';
import shopPageTemplateLimit from './limit-detectors/shop-page-template-limit';
import customDomain from './limit-detectors/custom-domain-limit';
import advancedWebsiteCustomizationLimit from './limit-detectors/advanced-website-customization-limit';
import passwordProtectedPages from './limit-detectors/password-protected-pages-limit';
import formAttachmentsLimit from './limit-detectors/form-attachments-limit';
import aiPageWizardLimit from './limit-detectors/ai-page-wizard-limit';
import aiBlockGenerationQuota from './limit-detectors/ai-block-generation-limit';
import aiTextAssistantQuota from './limit-detectors/ai-text-assistant-limit';
import premiumButtonPresetsLimit from './limit-detectors/premium-button-presets-limit';
import premiumTextDecorationsLimit from './limit-detectors/premium-text-decorations-limit';
import premiumCompositeGroupLimit from './limit-detectors/premium-composite-group-limit';
import aiLocalizationLimit from './limit-detectors/ai-localization-limit';

const calculateFeatureLimits = ({
  availablePlatformComponents,
  activeSubscriptions,
  availableSubscriptionTypes,
  availableNonPaidFeatures,
  userFeatures,
  targetPackage,
  featureFlags,
}) => ({
  advancedWebsiteCustomization: advancedWebsiteCustomizationLimit({ targetPackage }),
  advertising: advertisingLimit({ availableSubscriptionTypes }),
  analytics: analyticsLimit({ availableNonPaidFeatures, availablePlatformComponents }),
  premiumIcons: premiumIconsLimit({ targetPackage }),
  premiumBlocks: premiumBlocksLimit({ targetPackage }),
  mobilePlus: mobilePlusLimit({ targetPackage }),
  customCode: customCodeLimit({ targetPackage }),
  brandedFooter: brandedFooterLimit({ targetPackage, userFeatures, featureFlags }),
  brandedHeader: brandedHeaderLimit({ targetPackage, userFeatures, featureFlags }),
  pagesCount: pagesLimit({ targetPackage }),
  storageLimit: storageLimit({ targetPackage }),
  uploadFileSize: uploadFileSizeLimit({ targetPackage }),
  onlineStore: onlineStoreLimit({ activeSubscriptions, availableSubscriptionTypes }),
  siteBackupsLimit: siteBackupsLimit({ targetPackage }),
  multilingualLimit: multilingualLimit({ targetPackage }),
  shopPageTemplateLimit: shopPageTemplateLimit({ availableSubscriptionTypes }),
  customDomain: customDomain({ targetPackage }),
  passwordProtectedPages: passwordProtectedPages({ targetPackage }),
  formAttachments: formAttachmentsLimit({ targetPackage }),
  aiPageWizard: aiPageWizardLimit({ targetPackage }),
  aiBlockGenerationQuota: aiBlockGenerationQuota({ targetPackage }),
  aiTextAssistantQuota: aiTextAssistantQuota({ targetPackage }),
  aiLocalization: aiLocalizationLimit({ targetPackage }),
  premiumButtonPresets: premiumButtonPresetsLimit({ targetPackage }),
  premiumTextDecorations: premiumTextDecorationsLimit({ targetPackage }),
  premiumCompositeGroup: premiumCompositeGroupLimit({ targetPackage }),
});

export default calculateFeatureLimits;
